import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ roles }) => {
  const authLocalstorageStr = sessionStorage.getItem('authLocalstorage');
  
  // If there's no auth data in session storage, redirect to the login page
  if (!authLocalstorageStr) {
    return <Navigate to="/" />;
  }
  
  try {
    const authLocalstorage = JSON.parse(authLocalstorageStr);
    
    // If there's no token in the auth data, redirect to the login page
    if (!authLocalstorage || !authLocalstorage.token) {
      return <Navigate to="/" />;
    }
    
    // Check if roles array exists before checking access
    if (!authLocalstorage.roles || !Array.isArray(authLocalstorage.roles)) {
      return <Navigate to="/" />;
    }

    // Check if the user's role is in the provided roles
    const hasAccess = roles.some(role => authLocalstorage.roles.includes(role));

    // If the user doesn't have access to any of the roles, redirect to NotAuthorized page
    if (!hasAccess) {
      return <Navigate to="/NotAuthorized" />;
    }

    // If authorized, render the children route
    return <Outlet />;
  } catch (error) {
    console.error('Error parsing authentication data:', error);
    // If there's an error parsing the auth data, redirect to the login page
    return <Navigate to="/" />;
  }
};

export default ProtectedRoute;
